"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var MailApi = /** @class */ (function (_super) {
    __extends(MailApi, _super);
    function MailApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a new mail user.
     * Add mail user
     */
    MailApi.prototype.addMailUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null ||
                            requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling addMailUser.');
                        }
                        if (requestParameters.password === null ||
                            requestParameters.password === undefined) {
                            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling addMailUser.');
                        }
                        if (requestParameters.privileges === null ||
                            requestParameters.privileges === undefined) {
                            throw new runtime.RequiredError('privileges', 'Required parameter requestParameters.privileges was null or undefined when calling addMailUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.email !== undefined) {
                            formParams.append('email', requestParameters.email);
                        }
                        if (requestParameters.password !== undefined) {
                            formParams.append('password', requestParameters.password);
                        }
                        if (requestParameters.privileges !== undefined) {
                            formParams.append('privileges', requestParameters.privileges);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/add",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds a new mail user.
     * Add mail user
     */
    MailApi.prototype.addMailUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addMailUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds a privilege to an existing mail user.
     * Add mail user privilege
     */
    MailApi.prototype.addMailUserPrivilegeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null ||
                            requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling addMailUserPrivilege.');
                        }
                        if (requestParameters.privilege === null ||
                            requestParameters.privilege === undefined) {
                            throw new runtime.RequiredError('privilege', 'Required parameter requestParameters.privilege was null or undefined when calling addMailUserPrivilege.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.email !== undefined) {
                            formParams.append('email', requestParameters.email);
                        }
                        if (requestParameters.privilege !== undefined) {
                            formParams.append('privilege', requestParameters.privilege);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/privileges/add",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds a privilege to an existing mail user.
     * Add mail user privilege
     */
    MailApi.prototype.addMailUserPrivilege = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addMailUserPrivilegeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all mail aliases.
     * Get mail aliases
     */
    MailApi.prototype.getMailAliasesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.format !== undefined) {
                            queryParameters['format'] = requestParameters.format;
                        }
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/aliases",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(models_1.MailAliasByDomainFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Returns all mail aliases.
     * Get mail aliases
     */
    MailApi.prototype.getMailAliases = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMailAliasesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all mail domains.
     * Get mail domains
     */
    MailApi.prototype.getMailDomainsRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/domains",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns all mail domains.
     * Get mail domains
     */
    MailApi.prototype.getMailDomains = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMailDomainsRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all privileges for an existing mail user.
     * Get mail user privileges
     */
    MailApi.prototype.getMailUserPrivilegesRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/privileges",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.MailUserPrivilegeFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all privileges for an existing mail user.
     * Get mail user privileges
     */
    MailApi.prototype.getMailUserPrivileges = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMailUserPrivilegesRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns all mail users.
     * Get mail users
     */
    MailApi.prototype.getMailUsersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.format !== undefined) {
                            queryParameters['format'] = requestParameters.format;
                        }
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.MailUsersResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns all mail users.
     * Get mail users
     */
    MailApi.prototype.getMailUsers = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMailUsersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes a mail alias.
     * Remove mail alias
     */
    MailApi.prototype.removeMailAliasRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.address === null ||
                            requestParameters.address === undefined) {
                            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling removeMailAlias.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.address !== undefined) {
                            formParams.append('address', requestParameters.address);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/aliases/remove",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Removes a mail alias.
     * Remove mail alias
     */
    MailApi.prototype.removeMailAlias = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeMailAliasRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes an existing mail user.
     * Remove mail user
     */
    MailApi.prototype.removeMailUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null ||
                            requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling removeMailUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.email !== undefined) {
                            formParams.append('email', requestParameters.email);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/remove",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Removes an existing mail user.
     * Remove mail user
     */
    MailApi.prototype.removeMailUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeMailUserRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes a privilege from an existing mail user.
     * Remove mail user privilege
     */
    MailApi.prototype.removeMailUserPrivilegeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null ||
                            requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling removeMailUserPrivilege.');
                        }
                        if (requestParameters.privilege === null ||
                            requestParameters.privilege === undefined) {
                            throw new runtime.RequiredError('privilege', 'Required parameter requestParameters.privilege was null or undefined when calling removeMailUserPrivilege.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.email !== undefined) {
                            formParams.append('email', requestParameters.email);
                        }
                        if (requestParameters.privilege !== undefined) {
                            formParams.append('privilege', requestParameters.privilege);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/privileges/remove",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Removes a privilege from an existing mail user.
     * Remove mail user privilege
     */
    MailApi.prototype.removeMailUserPrivilege = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeMailUserPrivilegeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Sets a password for an existing mail user.
     * Set mail user password
     */
    MailApi.prototype.setMailUserPasswordRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.email === null ||
                            requestParameters.email === undefined) {
                            throw new runtime.RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling setMailUserPassword.');
                        }
                        if (requestParameters.password === null ||
                            requestParameters.password === undefined) {
                            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling setMailUserPassword.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.email !== undefined) {
                            formParams.append('email', requestParameters.email);
                        }
                        if (requestParameters.password !== undefined) {
                            formParams.append('password', requestParameters.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/users/password",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Sets a password for an existing mail user.
     * Set mail user password
     */
    MailApi.prototype.setMailUserPassword = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setMailUserPasswordRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Adds or updates a mail alias. If updating, you need to set `update_if_exists: 1`.
     * Upsert mail alias
     */
    MailApi.prototype.upsertMailAliasRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.updateIfExists === null ||
                            requestParameters.updateIfExists === undefined) {
                            throw new runtime.RequiredError('updateIfExists', 'Required parameter requestParameters.updateIfExists was null or undefined when calling upsertMailAlias.');
                        }
                        if (requestParameters.address === null ||
                            requestParameters.address === undefined) {
                            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling upsertMailAlias.');
                        }
                        if (requestParameters.forwardsTo === null ||
                            requestParameters.forwardsTo === undefined) {
                            throw new runtime.RequiredError('forwardsTo', 'Required parameter requestParameters.forwardsTo was null or undefined when calling upsertMailAlias.');
                        }
                        if (requestParameters.permittedSenders === null ||
                            requestParameters.permittedSenders === undefined) {
                            throw new runtime.RequiredError('permittedSenders', 'Required parameter requestParameters.permittedSenders was null or undefined when calling upsertMailAlias.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.updateIfExists !== undefined) {
                            formParams.append('update_if_exists', requestParameters.updateIfExists);
                        }
                        if (requestParameters.address !== undefined) {
                            formParams.append('address', requestParameters.address);
                        }
                        if (requestParameters.forwardsTo !== undefined) {
                            formParams.append('forwards_to', requestParameters.forwardsTo);
                        }
                        if (requestParameters.permittedSenders !== undefined) {
                            formParams.append('permitted_senders', requestParameters.permittedSenders);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/mail/aliases/add",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Adds or updates a mail alias. If updating, you need to set `update_if_exists: 1`.
     * Upsert mail alias
     */
    MailApi.prototype.upsertMailAlias = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.upsertMailAliasRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return MailApi;
}(runtime.BaseAPI));
exports.MailApi = MailApi;
